// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import '../stylesheets/application.scss';
import 'packs/main.js';
import 'packs/main2.js';
import 'packs/main3.js';
import 'packs/main4.js';
import 'packs/main5.js';
import 'packs/main7.js';

Rails.start()
//= require jquery.turbolinks

ActiveStorage.start()

require("trix")
require("@rails/actiontext")